var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { GALLERY_CONSTS } from "pro-gallery";
import { migrateOptions } from "pro-gallery-lib";
import { useContext, useMemo } from "react";
import { RicosContext } from "./../../ricos-context";
import { GalleryOptions_Layout_Type as GALLERY_LAYOUT } from "./../../ricos-schema/legacy/wix/rich_content/v1";
import { getFixedStyles } from "../defaults";
import { GALLERY_LAYOUT_TO_NUMBER, isHorizontalLayout, SCROLL_DIRECTION_TO_NUMBER } from "./utils";
const convertToGalleryOptions = (options) => {
  const galleryOptions = {};
  const { layout, thumbnails, item } = options;
  if (layout) {
    const { type, horizontalScroll, orientation, numberOfColumns, mobileNumberOfColumns } = layout;
    type && (galleryOptions.galleryLayout = parseInt(GALLERY_LAYOUT_TO_NUMBER[type]));
    horizontalScroll && (galleryOptions.scrollDirection = SCROLL_DIRECTION_TO_NUMBER[GALLERY_CONSTS.layoutParams_structure_scrollDirection.HORIZONTAL]);
    orientation && (galleryOptions.isVertical = orientation === "COLUMNS");
    typeof numberOfColumns === "number" && (galleryOptions.numberOfImagesPerRow = numberOfColumns);
    typeof mobileNumberOfColumns === "number" && (galleryOptions.m_numberOfImagesPerRow = mobileNumberOfColumns);
  }
  if (item) {
    const { targetSize, ratio, crop, spacing } = item;
    typeof targetSize === "number" && (galleryOptions.gallerySizePx = targetSize);
    typeof ratio === "number" && (galleryOptions.cubeRatio = ratio);
    crop && (galleryOptions.cubeType = crop.toLowerCase());
    typeof spacing === "number" && (galleryOptions.imageMargin = spacing);
  }
  if (thumbnails) {
    const { placement, spacing } = thumbnails;
    placement && (galleryOptions.galleryThumbnailsAlignment = placement.toLowerCase());
    typeof spacing === "number" && (galleryOptions.thumbnailSpacings = spacing / 2);
  }
  return galleryOptions;
};
function useOptions(options, disableDownload) {
  const { isMobile } = useContext(RicosContext);
  const galleryOptions = useMemo(() => {
    var _a;
    const isHorizontal = isHorizontalLayout(options);
    const calculatedOptions = __spreadValues(__spreadProps(__spreadValues({}, getFixedStyles(((_a = options.layout) == null ? void 0 : _a.type) || GALLERY_LAYOUT.GRID)), {
      allowContextMenu: !disableDownload,
      showArrows: isHorizontal,
      responsive: true
    }), convertToGalleryOptions(options));
    if (isMobile) {
      if (calculatedOptions.m_numberOfImagesPerRow) {
        calculatedOptions.numberOfImagesPerRow = calculatedOptions.m_numberOfImagesPerRow;
      }
      if (isHorizontal) {
        calculatedOptions.arrowsSize = 20;
        !calculatedOptions.imageMargin && (calculatedOptions.imageMargin = 0);
        if (calculatedOptions.galleryLayout === GALLERY_LAYOUT_TO_NUMBER[GALLERY_LAYOUT.THUMBNAIL]) {
          calculatedOptions.thumbnailSize = 90;
        }
      }
    }
    return { options: migrateOptions(calculatedOptions), calculatedOptions };
  }, [options]);
  return galleryOptions;
}
export {
  useOptions
};
//# sourceMappingURL=useOptions.js.map
